import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchOnLoadDataService = async (access_token) => {
  try {
    return axios.get(`${api}/DrugAssignment/BulkAssignDrug_Onload`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const getNumberOfDrugsService = async (access_token, data) => {
  try {
    return axios.post(`${api}/DrugAssignment/GetDrugCount`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const saveBulkDataService = async (access_token, data) => {
  try {
    return axios.post(`${api}/DrugAssignment/PostBulkAssignDrug`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchAllIndividualDrugService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    const filter = {
      // drugTypeName: debouncedSearch,
      // depotName: debouncedSearch,
      // kitNumber: debouncedSearch,
      // sequenceNumber: debouncedSearch,
      // labelGroupName: debouncedSearch,
      // quantityToAssign: debouncedSearch,
      // quantity: debouncedSearch,
    };
    return axios.get(
      `${api}/DrugAssignment/GetDrugAssignmentGridData?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const saveIndividualDrugDataService = async (
  access_token,
  data,
  userId
) => {
  try {
    return axios.post(
      `${api}/DrugAssignment/PostAssignDrug?PerformedByUserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};
